import React, { createContext, ReactNode } from "react";
import AttendeeService from "../dataProvider/services/Attendee.service";
import AttendeeFieldService from "../dataProvider/services/AttendeeField.service";
import FileService from "../dataProvider/services/File.service";
import EventService from "./../dataProvider/services/Event.service";
import UserService from "./../dataProvider/services/User.service";
import BadgeTemplateService from "./../dataProvider/services/BadgeTemplate.service";
import BadgeFormatService from "./../dataProvider/services/BadgeFormat.service";
import SessionService from "../dataProvider/services/Session.service";
import AccountService from "../dataProvider/services/Account.service";
import LocationService from "../dataProvider/services/Location.service";
import DeveloperAccountService from "../dataProvider/services/DeveloperAccount.service";
import AlertService from "./../dataProvider/services/Alert.service";
import AnalyticsService from "../dataProvider/services/Analytics.service";
import AnalyticsSettingsService from "../dataProvider/services/AnalyticsSettings.service";
import LeadsService from "../dataProvider/services/Leads.service";
import apiCalls from "../Configs/config";

export type Config = {
  swaggerUrl: string;
  apiUrl: string;
  badgeDesignerUrl: string;
  leadsUrl:string;
  analyticsApiUrl: string;
  analyticsSettingsApiUrl: string;
  environment: string;
  portalV2Url: string;
};

export type FdServices = {
  eventService: EventService;
  userService: UserService;
  attendeeService: AttendeeService;
  fileService: FileService;
  attendeeFieldService: AttendeeFieldService;
  badgeTemplateService: any;
  badgeFormatService: any;
  sessionService: SessionService;
  accountService: AccountService;
  locationService: LocationService;
  developerAccountService: DeveloperAccountService;
  alertService: AlertService;
  analyticsService: AnalyticsService;
  analyticsSettingsService: AnalyticsSettingsService;
  leadsService: LeadsService
};

export interface Configuration extends Config, FdServices{}

type Props = {
  config: Config;
  children: ReactNode;
};

export const APIContext = createContext<Configuration>({} as Configuration);

const APIProvider: React.FC<Props> = ({ children, config }) => {
  return (
    <APIContext.Provider
      value={{
        ...config,
        eventService: new EventService(config.apiUrl),
        userService: new UserService(config.apiUrl),
        attendeeService: new AttendeeService(config.apiUrl),
        fileService: new FileService(config.apiUrl),
        attendeeFieldService: new AttendeeFieldService(config.apiUrl),
        badgeTemplateService: new BadgeTemplateService(config.apiUrl),
        badgeFormatService: new BadgeFormatService(config.apiUrl),
        sessionService: new SessionService(config.apiUrl),
        accountService: new AccountService(config.apiUrl),
        locationService: new LocationService(config.apiUrl),
        developerAccountService: new DeveloperAccountService(config.apiUrl),
        alertService: new AlertService(config.apiUrl),
        analyticsService: new AnalyticsService(apiCalls.analyticsApiUrl),
        analyticsSettingsService: new AnalyticsSettingsService(
          apiCalls.analyticsSettingsApiUrl
        ),
        leadsService: new LeadsService(apiCalls.leadsUrl),

      }}
    >
      {children}
    </APIContext.Provider>
  );
};

export default APIProvider;
